import CombatSpellAttack from './CombatSpellAttack';

export default CombatSpellAttack;
export { CombatSpellAttack };
